$(window).on('js-onload', function(){

    $('#cart-form').preventReturnSubmit();

    $('.cart-row-form')

        .on('input', ':input', function(event) {
            var $form = $(event.delegateTarget);
            var $btn = $form.find('.cart-row-update');

            $btn.enable().show();
        })

        .on('input', '.product-quantity-input', function(){
            var $input = $(this);

            if($input.val() < 1) {
                $input.val(1);
            }
        })

        .on('click', '.cart-row-update', function(event) {
            event.preventDefault();

            var $form = $(event.delegateTarget);
            var $btn = $(this);

            $btn.disable().addClass('loading');
            $btn.closest('.cart-row-form').find('.alert:first').remove();

            $.post('/cart/update-row', $form.find(':input').serialize(), null, 'json')
                .fail(function(xhr) {

                    var message = 'There was a problem updating this item.';

                    if(xhr.responseJSON !== undefined) {
                        if(xhr.responseJSON.errors !== undefined) {
                            message = '<b>Unable to update item:</b><ul>';

                            $.each(xhr.responseJSON.errors, function(key, value) {
                                message += '<li>'+value+'</li>';
                            });

                            message += '</ul>';

                        } else if(xhr.responseJSON.message !== undefined) {
                            message = xhr.responseJSON.message;
                        }
                    }

                    $btn.closest('.cart-row-form').prependAlert(message);
                })
                .always(function() {
                    $btn.enable().removeClass('loading');
                })
                .done(function(response) {
                    if(response.hasOwnProperty('gtm')) {
                        window.dataLayerPush(response.gtm);
                    }

                    $form.closest('tr').find('.cart-row-total:first').html('$' + response.row_total);

                    $('#cart-table-total').html('$' + response.cart_total);

                    $btn.disable().hide();
                    $btn.next('.success-check').addClass('success');
                    setTimeout(function(){
                        $btn.next('.success-check').removeClass('success');
                    }, 2000);
                });
        });

});